import React, { Component } from 'react';
import styled from 'styled-components';
import { trackAnalytics, attachLocale, isSlug, makeExternalUrl } from '../../../../lib/utils';
import {
  DATA_TRACK_ROLE_CONTAINER, DL_SMALL_PROMO_BANNER,
  DOM_LAYOUT_SMALL_PROMO_BANNER,
} from '../../../../lib/constants';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import { addItemsToDataLayer, dataLayerIdGenerator, dataLayerIdGeneratorNewItem } from '../../../../lib/dataLayerUtils';
import SymbolFormat from '../shared/SymbolFormat';
import Button from '../Button/Button';

const SmallPromoBannerContainerDiv = styled.div`
  border: solid 1px ${p => p.theme.c.border.primary};
  display: flex;
  align-items: center;
  min-height: ${p => p.theme.unit(29)};
  flex-direction: ${p => ((p.isMobile ? 'column-reverse' : 'row'))};
  margin-bottom: ${p => (p.isMobile ? p.theme.unit(6) : p.theme.unit(8))};
  margin-top: ${p => (p.isMobile ? p.theme.unit(6) : p.theme.unit(8))};
  margin-right: ${p => (p.isMobile ? p.theme.unit(2) : 'initial')};
  margin-left: ${p => (p.isMobile ? p.theme.unit(2) : 'initial')};
  padding-top: ${p => (p.isMobile ? p.theme.unit(2.5) : 'initial')};
  overflow: hidden;
`;

const SmallPromoBannerContentDiv = styled.div`
  width: ${p => (p.isMobile ? 'initial' : '60%')};
  margin-left: ${p => (p.isMobile ? p.theme.unit(2) : p.theme.unit(5))};
  margin-right: ${p => (p.isMobile ? p.theme.unit(2) : p.theme.unit(5))};
  padding-top: ${p => (p.isMobile ? p.theme.unit(2) : 0)};
`;

const SmallPromoBannerHeaderTextDiv = styled.div`
${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${p => p.theme.c.text.primary};
  margin-bottom: ${p => p.theme.unit(1)};
  width: max-content;
  @media screen and (max-width: ${p => p.theme.breakpoint.mobile}px) {
    width: fit-content;
  }
  
`;

const SmallPromoBannerSubHeaderTextDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
  margin-bottom: ${p => p.theme.unit(3)};
`;

const SmallPromoBannerButtonDiv = styled.div`
  width: ${p => (p.isMobile ? '100%' : 'fit-content')};
  margin-bottom: ${p => (p.isMobile ? p.theme.unit(3) : 'initial')};
`;

const SmallPromoBannerImageDiv = styled.div`
  width: ${p => (p.isMobile ? 'initial' : '40%')};
  text-align: ${p => (p.isMobile ? 'center' : 'right')};
  margin-right: ${p => (p.isMobile ? 0 : p.theme.unit(8))};
`;

const SmallPromoBannerImg = styled.img`
  max-height: ${p => (p.isMobile ? p.theme.unit(18) : p.theme.unit(19))};
`;

class LayoutSmallPromoBanner extends Component {
  constructor(props) {
    super(props);

    const itemSlug = this.props.slug ? this.props.slug : '';
    const dataLayerId = dataLayerIdGenerator(DL_SMALL_PROMO_BANNER, itemSlug);
    this.state = {
      dataLayerId,
    };

  }

  // Analytics: Update dataLayer with new items
  componentDidMount() {
    const itemType = DL_SMALL_PROMO_BANNER;
    const newItem = dataLayerIdGeneratorNewItem(itemType, this.props, this.state.dataLayerId);
    const items = [newItem];
    addItemsToDataLayer(items, itemType);
  }

  render() {
    const {
      headerText = '',
      subHeaderText = '',
      buttonText = '',
      buttonDescriptiveText = null,
      buttonUrl = '',
      imageUrl = '',
      tags = {},
      slug = '',
      locale = 'en',
    } = this.props;

    const imgSrc = makeExternalUrl(imageUrl);

    const resolvedUrl = isSlug(buttonUrl) ? attachLocale(buttonUrl, locale) : makeExternalUrl(buttonUrl);
    const track = trackAnalytics(DOM_LAYOUT_SMALL_PROMO_BANNER, `${slug}-${DOM_LAYOUT_SMALL_PROMO_BANNER}`, resolvedUrl, tags);

    const DesktopBody = () => (
      <SmallPromoBannerContainerDiv data-track-role={DATA_TRACK_ROLE_CONTAINER} data-layer-source-id={this.state.dataLayerId}>
        <SmallPromoBannerContentDiv>
          <SmallPromoBannerHeaderTextDiv>
            <SymbolFormat text={headerText} />
          </SmallPromoBannerHeaderTextDiv>
          <SmallPromoBannerSubHeaderTextDiv>
            <SymbolFormat text={subHeaderText} />
          </SmallPromoBannerSubHeaderTextDiv>
          <SmallPromoBannerButtonDiv>
            {buttonText && (
              <Button
                variant="secondary"
                size="medium"
                target="_blank"
                rel="noreferrer noopener"
                buttonText={buttonText}
                dataLayerId={this.state.dataLayerId}
                accessibleLabel={buttonDescriptiveText}
                {...track}
              />
            )}
          </SmallPromoBannerButtonDiv>
        </SmallPromoBannerContentDiv>
        <SmallPromoBannerImageDiv>
          <SmallPromoBannerImg src={imgSrc} alt="" />
        </SmallPromoBannerImageDiv>
      </SmallPromoBannerContainerDiv>
    );

    const MobileBody = () => (
      <SmallPromoBannerContainerDiv isMobile data-track-role={DATA_TRACK_ROLE_CONTAINER} data-layer-source-id={this.state.dataLayerId}>
        <SmallPromoBannerContentDiv isMobile>
          <SmallPromoBannerHeaderTextDiv>
            <SymbolFormat text={headerText} />
          </SmallPromoBannerHeaderTextDiv>
          <SmallPromoBannerSubHeaderTextDiv>
            <SymbolFormat text={subHeaderText} />
          </SmallPromoBannerSubHeaderTextDiv>
          <SmallPromoBannerButtonDiv isMobile>
            {buttonText && (
              <Button
                variant="secondary"
                size="medium"
                target="_blank"
                rel="noreferrer noopener"
                buttonText={buttonText}
                dataLayerId={this.state.dataLayerId}
                accessibleLabel={buttonDescriptiveText}
                {...track}
              />
            )}
          </SmallPromoBannerButtonDiv>
        </SmallPromoBannerContentDiv>
        <SmallPromoBannerImageDiv isMobile>
          <SmallPromoBannerImg isMobile src={imgSrc} alt="" />
        </SmallPromoBannerImageDiv>
      </SmallPromoBannerContainerDiv>
    );

    const renderComp = (
      <MediaQueryHelper
        desktopChildren={DesktopBody()}
        mobileChildren={MobileBody()} />);
    return renderComp;
  }
}

export default LayoutSmallPromoBanner;
